module.exports = __webpack_public_path__ + "media/images/bt-entrega-comum-clicado-46d6e41c2c0824430ada346deb950849.svg";